// Drill-down route: /usage-logs/:callId
// Renders the UsageCallDrilldown panel for a single LLM call log entry.
// Filter state lives in the parent component (not URL), so the back link
// simply navigates to /usage-logs without search params.
import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/lib/auth/require-role";
import { useUsageLog } from "@/features/usage-logs/hooks/use-usage-log";
import { UsageCallDrilldown } from "@/features/usage-logs/components/UsageCallDrilldown";

export const Route = createFileRoute("/_admin/usage-logs/$callId")({
  beforeLoad: () => requireRole("admin"),
  component: UsageLogDetailRoute,
});

function UsageLogDetailRoute() {
  const { callId } = Route.useParams();
  const { data, isLoading } = useUsageLog(callId);

  return <UsageCallDrilldown log={data} isLoading={isLoading} />;
}
